import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ContactUs.css';

const ContactUs: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="contact-container">
      <div className="contact-content">
        <h1>Contact Us</h1>
        <p className="contact-intro">
          Have questions about custom pricing, monthly stays, or want to discuss your booking? Call, text, or email us - we're here to help!
        </p>

        <div className="contact-details">
          <div className="contact-item">
            <div className="contact-icon">👤</div>
            <div className="contact-info">
              <h3>Name</h3>
              <p>Aaron</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">📞</div>
            <div className="contact-info">
              <h3>Phone</h3>
              <a href="tel:9494784034" className="contact-link">(949) 478-4034</a>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">✉️</div>
            <div className="contact-info">
              <h3>Email</h3>
              <a href="mailto:support@theacademicloft.com" className="contact-link">support@theacademicloft.com</a>
            </div>
          </div>
        </div>

        <button className="back-button" onClick={() => navigate('/')}>
          ← Back to Property
        </button>
      </div>
    </div>
  );
};

export default ContactUs;
